import React, { Component } from 'react'
import { get } from '../../utils/networking'
import { getPage } from './action'
import { connect } from 'react-redux'
export class Page extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.getPage(this.props.match.params.slug)
    }
    componentWillReceiveProps(nextProps) {
        this.props.getPage(nextProps.match.params.slug)
    }

    render() {
        let {
            title,
            content
        } = this.props

        return (
            <div>
                {title &&
                    <main>
                        <div className="border_line_bottom" style={{ marginTop: "80px" }}>
                            <div className="container">
                                <div className="content clearfix page_spa page_blog page_detail_blog">
                                    <div className="content_main clearfix">
                                        <div className="col_sm_12">
                                            <div className="list_spa">
                                                <div className="querytotalhitscount">
                                                    <hr />
                                                    <h3 className="title_page" style={{ textAlign: "center" }}>{title}</h3>
                                                    <hr />
                                                </div>
                                                <div className="row_col">
                                                    <div className="text">
                                                        <div dangerouslySetInnerHTML={{ __html: content }} className="text"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="right col_4 col_sm_12"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                }
            </div>
        )

    }
}

export default connect(
    state => ({
        ...state.page
    }),
    dispatch => ({
        getPage: (slug) => dispatch(getPage(slug))
    })
)(Page)


// WEBPACK FOOTER //
// ./src/components/page/index.js